import { z } from "zod";
import type { ProductionQuantityUnitOptions } from "./models";

const schema = z.object({
  available: z.boolean(), productCode: z.string(), primaryUnit: z.string(), defaultUnit: z.string().nullable(),
  options: z.array(z.object({ unit: z.string().min(1), factorToPrimary: z.number().positive().finite(), position: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]) })).max(4),
  source: z.literal("MIKRO_ERP").nullable(), observedAt: z.string().nullable(), unavailableReason: z.string().nullable(),
});
export function decodeQuantityUnitOptions(value: unknown): ProductionQuantityUnitOptions {
  const result = schema.parse(value);
  if (result.available && (!result.source || !result.observedAt || !result.options.length)) {
    throw new Error("Ürün birimleri için doğrulama bilgisi eksik.");
  }
  if (result.available) {
    const primary = result.options.find((option) => option.position === 1);
    const units = result.options.map((option) => normalizedProductionUnit(option.unit));
    if (!result.productCode.trim() || !Number.isFinite(Date.parse(result.observedAt ?? "")) ||
      !primary || normalizedProductionUnit(primary.unit) !== normalizedProductionUnit(result.primaryUnit) || primary.factorToPrimary !== 1 ||
      units.some((unit) => !unit) || new Set(units).size !== units.length ||
      new Set(result.options.map((option) => option.position)).size !== result.options.length ||
      (result.defaultUnit !== null && !units.includes(normalizedProductionUnit(result.defaultUnit)))) {
      throw new Error("Ürünün stok kartı birimleri tutarlı değil; miktar kaydı açılamadı.");
    }
  }
  return result;
}
export function normalizedProductionUnit(unit: string) {
  return unit.normalize("NFKD").replace(/\p{M}/gu, "").toUpperCase().trim();
}
export function individualQuantityOptions(contract: ProductionQuantityUnitOptions | null) {
  return contract?.available ? contract.options.filter((option) => normalizedProductionUnit(option.unit) !== "KOLI") : [];
}

export function quantityOptionsForProduct(contract: ProductionQuantityUnitOptions | null, productCode: string, primaryUnit: string,
  type: "PRODUCTION" | "WASTE" | "SCRAP") {
  if (!contract?.available || contract.productCode !== productCode ||
    normalizedProductionUnit(contract.primaryUnit) !== normalizedProductionUnit(primaryUnit)) return [];
  return type === "PRODUCTION" ? contract.options : individualQuantityOptions(contract);
}
